import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-tepler.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  TeplarDefaultSortColumnOrder,
  TeplarFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { ITeplarFilter } from '../../models/ITeplarFilter';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  DeleteIcon,
  EditIcon,
  HistoryIcon,
  ImportIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddEditTeplarPrint from './components/add-edit-teplar-print';
import FilterComponent from './components/filter';
import AddTeplarPrintPopupHOC from './hoc/add-teplar-print-popup-hoc';
import TeplarPrintDetails from './teplar-print-details';
import TeplarPrintFilesHistoryDetails from './teplar-print-files-history-details';
import './teplar-print.css';

const TeplarPrint = (props: any) => {
  const { preferencesStore, teplarPrintStore } = useStore();
  const {
    GetTeplarListService,
    allTeplars,
    teplarList,
    deleteTeplarState,
    resetDeleteTeplar,
    resetTeplarDetail,
    fileUploadState,
    resetFileUploadState,
    getAllTeplarState,
    maxItems,
    getTeplarByIdState,
    getTeplarDetailsByIdState,
    DeleteTeplarService,
    updateTeplarState,
    resetUpdateTeplarState,
    getTeplarFilesHistoryState,
  } = teplarPrintStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  let lang: string;
  const allTeplarsListData = allTeplars;
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    TeplarDefaultSortColumnOrder
  );
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [openHistoryPanel, setOpenHistoryPanel] = useState(false);
  const [filterObj, setFilterObj] = useState<ITeplarFilter>(
    TeplarFilterInitialState
  );

  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [isBulkDelete, setIsBulkDelete] = useState<boolean>(false);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
    setSelectedIds([]);
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getTeplarListServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }
    if (!isFilter) {
      GetTeplarListService(
        Number(getTenantIdFromLocalStorage()),
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        encodeURIComponent(filterQuery)
      );
    } else {
      GetTeplarListService(
        Number(getTenantIdFromLocalStorage()),
        1,
        pageLimitInfo.pageLimit,
        encodeURIComponent(filterQuery)
      );
    }
  };

  useEffect(() => {
    getTeplarListServiceHandler();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: teplarList?.PagingDetails?.CurrentPage,
      totalPages: teplarList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [teplarList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getTeplarListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getTeplarListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getTeplarListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (fileUploadState.success) {
      toast.success(formatMessage('added_success'));
      resetFileUploadState();
      getTeplarListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileUploadState.success]);

  useEffect(() => {
    if (fileUploadState.error) {
      getTeplarListServiceHandler();
      resetFileUploadState();
    }
  }, [fileUploadState.error]);

  useEffect(() => {
    if (deleteTeplarState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteTeplar();
      getTeplarListServiceHandler();
      setSelectedIds([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteTeplarState.success]);

  useEffect(() => {
    if (updateTeplarState.success) {
      getTeplarListServiceHandler();
      resetUpdateTeplarState();
    }
  }, [updateTeplarState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    // GetProcessByIdService(row.Id);
    setOpenHistoryPanel(false);
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const toggleHistoryDetails = () => {
    if (openHistoryPanel) {
      setOpenPanel(false);
    }

    if (!openPanel) {
      setOpenPanel((prev) => !prev);
    }

    setOpenHistoryPanel((prev) => !prev);
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
    setOpenHistoryPanel(false);
  };

  const refreshClickHandler = () => {
    getTeplarListServiceHandler();
    closePanelHandler();
    setSelectedIds([]);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetTeplarDetail();
    setIsBulkDelete(false);
    props.deletePopupToggleHandler();
  };

  const bulkDeleteClickHandler = () => {
    setIsBulkDelete(true);
    props.deletePopupToggleHandler();
  };

  const openAddTeplarHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetTeplarDetail();
    setSelectedId(row.Id);
    props.addToggleHandler(true);
  };

  function formatDate(date: Date) {
    const day = date.getDate(); // 13
    const month = date.getMonth(); // 11 (months are 0-indexed, so add 1)
    const year = date.getFullYear(); // 2024
    return new Date(year, month, day);
  }

  const createQueryString = (filter: ITeplarFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: ITeplarFilter) => {
    const filters = {
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };
    const filter = createQueryString({ ...filters });
    getTeplarListServiceHandler(filter, true);
    setFilterObj({ ...filters });
    props.filterPopupToggleHandler();
    closePanelHandler();
    setIsFilterCleared(false);
    // getProductListServiceHandler("added_date DESC", encodeURIComponent(filter));
    // setFilterString(encodeURIComponent(filter));
    // closePanelhandler();
    // props.filterPopupToggleHandler();
    // setIsFilterCleared(false);
  };

  const filterParams = (obj: ITeplarFilter, isFilterCleared: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });

    if (isFilterCleared) {
      setFilterObj({ ...obj });
      getTeplarListServiceHandler(filter);
      closePanelHandler();
      setIsFilterCleared(true);
      setSelectedIds([]);
    } else {
      setFilterObj({ ...obj });
    }
    // if (isfilterCleard) {
    //   setFilterObj({
    //     ...obj,
    //     EndDate: null,
    //     StartDate: null,
    //     ColumnOrder: `${getFieldName(sortColumn)}  ${sortOrder}`,
    //     TenantId: -1,
    //   });
    //   getProductListServiceHandler("added_date DESC");
    //   closePanelhandler();
    //   setIsFilterCleared(true);
    //   setFilterString("");
    // } else {
    //   setFilterObj({
    //     ...obj,
    //     ColumnOrder: `${getFieldName(sortColumn)}  ${sortOrder}`,
    //     TenantId:
    //       getTenantIdFromLocalStorage() === "-1"
    //         ? Number(selectedTenantId)
    //         : Number(getTenantIdFromLocalStorage()),
    //   });
    // }
    props.filterPopupToggleHandler();
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isEdit',
        handler: openAddTeplarHandler,
        icon: <EditIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.TeplarPrintTemplateManagement,
          'Edit'
        ),
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.TeplarPrintTemplateManagement,
          'Delete'
        ),
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
    ],
    ModuleType.TeplarPrintTemplateManagement
  );

  const generateDynamicColumns = (data: any[]) => {
    if (!data || data.length === 0) return [];

    return Array.from(
      // { length: Math.max(...data.map((row) => row.Items?.filter((item: string) => item.trim()).length || 0)) },
      { length: maxItems },
      (_, index) => ({
        dataField: `item_${index + 1}`,
        text: `${formatMessage('item')} ${index + 1}`,
        classes: 'show-Elipses',
        formatter: (_: any, row: any) =>
          row.Items?.filter((item: string) => item.trim())[index] || '-', // Remove empty or \r values
        title: (cell: string) => (cell && cell.length > 10 ? cell : undefined),
      })
    );
  };

  const staticColumns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'Katashiki',
      text: formatMessage('katashiki'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      // sort: true,
      // onSort: (field: string, order: 'asc' | 'desc') => {
      //   // Call your handler function with the order value
      //   setSortField(field);
      //   setSortOrder(order);
      //   getProcessListServiceHandler();
      // }
    },
    {
      dataField: 'ProductId',
      text: formatMessage('product_id'),
      classes: 'show-Elipses',
      hidden: false,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
    },

    {
      dataField: 'Format',
      text: formatMessage('format'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'Layout',
      text: formatMessage('layout'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'Width',
      text: formatMessage('width'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    // {
    //   dataField: 'Remarks',
    //   text: formatMessage('remarks'),
    //   classes: 'show-Elipses',
    //   title: (cell: string, row: any) => {
    //     return cell && cell.length > 10 ? cell : undefined;
    //   },
    // },
  ];

  const actionsColumn = {
    dataField: '',
    formatter: CustomActionFormatter(actionIcons),
    text: formatMessage('actions'),
    classes: 'last-column',
    hidden: actionIcons.length > 0 ? false : true,
  };

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selectedIds,
    selectionRenderer: ({ mode, checked, disabled }: any) => (
      <input
        type={mode}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        readOnly
      />
    ),
    selectionHeaderRenderer: ({ checked, indeterminate }: any) => (
      <input
        type="checkbox"
        checked={checked}
        ref={(input: HTMLInputElement | null) => {
          if (input) input.indeterminate = indeterminate;
        }}
        className="form-check-input"
        readOnly
      />
    ),
    onSelect: (row: any, isSelect: boolean) => {
      if (isSelect) {
        setSelectedIds((prev) => [...prev, row.Id]);
      } else {
        setSelectedIds((prev) => prev.filter((id) => id !== row.Id));
      }
    },
    onSelectAll: (isSelect: boolean, rows: any[]) => {
      if (isSelect) {
        setSelectedIds(rows.map((row) => row.Id));
      } else {
        setSelectedIds([]);
      }
    },
  };

  const deleteHandler = () => {
    const idsToDelete = isBulkDelete ? selectedIds : [selectedId];
    DeleteTeplarService(Number(getTenantIdFromLocalStorage()), idsToDelete);
  };

  const columns = [
    ...staticColumns,
    actionsColumn,
    ...generateDynamicColumns(allTeplarsListData),
  ];

  return (
    <>
      {props.showAddTeplarPopup && (
        <AddEditTeplarPrint
          key={selectedId}
          id={selectedId}
          modalClosed={() => props.addToggleHandler(false)}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_teplar"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message={
            isBulkDelete
              ? 'message_delete_teplar_confirm_selected'
              : 'message_delete_teplar_confirm'
          }
          isLoading={deleteTeplarState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col-lg-6 col-md-6 col-sm-6"
            label="teplar_print_title"
          />
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isFilterCleared={isFilterCleared}
                  isLoading={false}
                  isDisable={false}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                />
              </li>
              {/* {selectedIds.length > 0 && ( */}
              <li>
                <button
                  disabled={selectedIds.length > 0 ? false : true}
                  className="btn btn-light btn-danger"
                  title={formatMessage('bulk_delete')}
                  type="button"
                  onClick={() => bulkDeleteClickHandler()}
                >
                  <DeleteIcon />
                </button>

                {/* </a> */}
              </li>
              {/* )} */}
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.TeplarPrintTemplateManagement,
                'Add'
              ) && (
                <li title={formatMessage('import_teplar')}>
                  <a
                    className="btn btn-primary d-flex align-items-center"
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      openAddTeplarHandler({ Id: -1 }, event)
                    }
                  >
                    <span className="me-1">
                      {' '}
                      <ImportIcon />
                    </span>
                    <FormattedMessage id="import_teplar" />
                  </a>
                </li>
              )}

              <li title={formatMessage('history')}>
                <a
                  className="btn btn-secondary d-flex align-items-center"
                  data-toggle="modal"
                  data-testid="modalbtn"
                  data-target="#addUser"
                  onClick={toggleHistoryDetails}
                >
                  <span className="me-1">
                    {' '}
                    <HistoryIcon />
                  </span>
                  <FormattedMessage id="history" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllTeplarState.inProgress ||
            getTeplarByIdState.inProgress ||
            getTeplarDetailsByIdState.inProgress ||
            deleteTeplarState.inProgress ||
            getTeplarFilesHistoryState.inProgress) && (
            <FormLoader
              loading={
                getAllTeplarState.inProgress ||
                getTeplarByIdState.inProgress ||
                getTeplarDetailsByIdState.inProgress ||
                deleteTeplarState.inProgress ||
                getTeplarFilesHistoryState.inProgress
              }
            />
          )}
          {allTeplarsListData && allTeplarsListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel teplarTable">
                  <div
                    className="table-responsive tray-management-table"
                    data-testid="table"
                  >
                    {allTeplarsListData && (
                      <Grid
                        data={allTeplarsListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        selectRow={selectRow}
                        // sort={{dataField: 'ProcessName', order: sortOrder}}
                        // remote = {{sort: true}}
                        // onTableChange={onTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allTeplarsListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={teplarList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_teplar_print" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_teplar_print_message')}
                  </h4>
                  {isOperationPermittedRoleBase(
                    ModuleType.TeplarPrintTemplateManagement,
                    'Add'
                  ) && (
                    <>
                      <a
                        className="btn btn-primary"
                        onClick={(event: any) =>
                          openAddTeplarHandler({ Id: -1 }, event)
                        }
                      >
                        <span className="me-1">
                          {' '}
                          <ImportIcon />
                        </span>
                        <FormattedMessage id="import_teplar" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {}
                {!openHistoryPanel ? (
                  selectedRow.ProductId
                ) : (
                  <FormattedMessage id="history" />
                )}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper">
            {!openHistoryPanel ? (
              <TeplarPrintDetails selectedRowId={selectedRow.Id} />
            ) : (
              <TeplarPrintFilesHistoryDetails />
            )}
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default FilterPopupHOC(
  AddTeplarPrintPopupHOC(DeletePopupHOC(observer(TeplarPrint)))
);
